module.exports = __webpack_public_path__ + "static/media/Maf_Curso_07DerechosNinosyAdolecentes.f5fdb268.jpg";